import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { AccessDeniedList } from "../shared/ui/AccessDeniedList";
import { useGlobalTenants } from "../tenants/global/GlobalTenantProvider";
import { ClippingList } from "./ClippingList";
import { ClippingDetails } from "./details/ClippingDetails";

export const ClippingPage: FC = () => {
	const { selected } = useGlobalTenants();

	if (!selected.tenant) {
		return <AccessDeniedList />;
	}

	return (
		<Routes>
			<Route index element={<ClippingList />} />
			<Route path=":clippingId" element={<ClippingDetails />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
